/**
 * A navigation entry for a place this account may not use: still there, struck
 * through, with a not-allowed cursor and a small hint - a stop sign and one
 * sentence saying whom to ask. Hiding it instead would leave people not knowing
 * the place exists; a live link would lead to a refusal.
 *
 * Used for header words and Explore tabs whose feature is on for somebody but
 * not for this person (`pageLock` in `state/page-visibility.ts`). On `/ui`.
 */

import { html, svg, type TemplateResult } from 'lit';

const STOP = svg`<svg class="locked-nav-stop" width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
  <path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86z" fill="currentColor" />
  <rect x="6.5" y="10.6" width="11" height="2.8" rx="0.6" class="locked-nav-stop-bar" />
</svg>`;

let counter = 0;

/**
 * @param label  what the entry would say
 * @param hint   one or two short sentences: that there is no access, and whom to ask
 * @param buttonClass the class the live entry uses (`primary-nav-btn`, `context-tab tab-btn`)
 */
export function lockedNav(label: string | TemplateResult, hint: string, buttonClass: string): TemplateResult {
  const id = `locked-nav-hint-${++counter}`;
  return html`<span class="locked-nav">
    <button type="button" class="${buttonClass} is-locked" aria-disabled="true" aria-describedby=${id}
      @click=${(e: Event) => e.preventDefault()}>${label}</button>
    <span class="locked-nav-hint" role="tooltip" id=${id}>${STOP}<span>${hint}</span></span>
  </span>`;
}
